import moment from "moment";

const primarySponsor = (vqaRequestSponsors) => {
  const sponsors = vqaRequestSponsors ?? [];
  return sponsors.find((sponsor) => sponsor?.is_primary_sponsor) ?? sponsors[0];
};

const actorNameFor = (sponsor) => {
  const contactName = sponsor?.sponsor_contact_name;
  if (typeof contactName === "string" && contactName.trim() !== "") return contactName;
  return sponsor?.sponsor_name ?? "";
};

/** Pending-request activity placeholder: who requested it, and when, from real data. */
export const selectRequestPlaceholder = (vqaDetails) => {
  const sponsor = primarySponsor(vqaDetails?.vqa_request_sponsors);
  const requestedOn = vqaDetails?.vqa_request_created_on;
  const parsed = requestedOn ? moment.utc(requestedOn) : null;
  return {
    actor: actorNameFor(sponsor),
    requestedOnLabel: parsed?.isValid() ? parsed.format("MMMM D, YYYY") : "—",
  };
};
